/* eslint-disable no-unused-vars */

/**
 * Every Unleash toggle this app reads. Nothing may pass a bare string to
 * `useFeatureFlags()` or `useFlag()` — a literal is invisible to this enum and
 * to the weekly flag audit that reads it.
 */
export enum FEATURE_FLAGS {
  // flag-keep-group: flags we hold on to. Not to be removed, whatever their age — the weekly
  // feature flag audit skips everything until the next marker.
  userKyc = 'user-kyc',
  multipleRoles = 'multiple-roles',
  ticketSectionsEnabled = 'ticket-sections-enabled',
  contentHubSeatMapEditor = 'content-hub-seat-map-editor',
  proactiveCaptchaEnabled = 'proactive-captcha-enabled',

  // flag-audit-group: flags that may be cleaned up once nothing reads them. The weekly audit only
  // considers flags below this line. Empty for now — move a flag down here when its rollout is
  // finished and the feature it gates is staying.
}
